// extracted by mini-css-extract-plugin
module.exports =  {"menu":"menu-xeE06","button":"button-DNmYL","selected":"selected-S7SeK","spacing":"spacing-PVpEn","version-info-label":"version-info-label-rSTCy"};